import { Component, Input } from '@angular/core';

import { IMotMonth } from '@mot/components/mot-month/mot-month.interface';

@Component({
  selector: 'app-mot-month-view-annual-grid',
  templateUrl: './mot-month-view-annual-grid.component.html',
  styleUrls: ['./mot-month-view-annual-grid.component.scss']
})
export class MotMonthViewAnnualGridComponent {
  @Input() month!: IMotMonth;
  @Input() isMomoUser!: boolean;
}
